import React from "react";

import Styles from "./TableGeralData.module.css";

import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

const useStyles = makeStyles((theme) => ({
	tableActions: {
		width: "100%",
	},
}));

const TableGeralData = (props) => {
	const classes = useStyles();

	return (
		<div className={Styles["TableGeralData"]}>
			<Table className={classes.table} aria-label="Actions table">
				<TableHead>
					<TableRow className={Styles["MuiTableRow-head"]}>
						<TableCell
							className={Styles["MuiTableCell-head"]}
							align="left"
						>
							<div className={Styles["title"]}>Dados Gerais</div>
						</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					<TableRow className={Styles["MuiTableBody-root"]}>
						<TableCell
							className={Styles["MuiTableCell-root"]}
							align="left"
							component="th"
							scope="row"
						>
							<div>
								<div className={Styles["title"]}>
									Metodologia
								</div>
								<div className={Styles["subtitle"]}>
									{props.modality}
								</div>
							</div>
						</TableCell>
						<TableCell
							className={Styles["MuiTableCell-root"]}
							align="left"
							component="th"
							scope="row"
						>
							<div>
								<div className={Styles["title"]}>Estado</div>
								<div className={Styles["subtitle"]}>
									{props.status}
								</div>
							</div>
						</TableCell>
						<TableCell
							className={Styles["MuiTableCell-root"]}
							align="left"
							component="th"
							scope="row"
						>
							<div>
								<div className={Styles["title"]}>
									Data de Inicio
								</div>
								<div className={Styles["subtitle"]}>
									{props.startDate}
								</div>
							</div>
						</TableCell>
						<TableCell
							className={Styles["MuiTableCell-root"]}
							align="left"
							component="th"
							scope="row"
						>
							<div>
								<div className={Styles["title"]}>
									Data de Fim
								</div>
								<div className={Styles["subtitle"]}>
									{props.endDate}
								</div>
							</div>
						</TableCell>
						<TableCell
							className={Styles["MuiTableCell-root"]}
							align="left"
							component="th"
							scope="row"
						>
							<div>
								<div className={Styles["title"]}>
									Total de Horas
								</div>
								<div className={Styles["subtitle"]}>
									{props.duration}
								</div>
							</div>
						</TableCell>
					</TableRow>
				</TableBody>
			</Table>
		</div>
	);
};

export default TableGeralData;
